import { Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { ProductExtra } from '@nousmedis/cc-types';
import { Product } from '@nousmedis/cc-types';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-product-details-modal',
  templateUrl: './product-details-modal.component.html',
  styleUrls: ['./product-details-modal.component.scss']
})
export class ProductDetailsModalComponent implements OnInit{
  product: Product;

  constructor(private dialog: DynamicDialogConfig) {

  }
  ngOnInit(){
    

    if(!this.product){
      console.log("Primer producto: ", this.product)

      if (this.dialog.data) {
        this.product = this.dialog.data.product;
      }
      console.log("Segundo producto: ", this.product)
    }
    console.log(this.product) 
  }

}
